module.exports = __webpack_public_path__ + "assets/e54d287c2105c3c1bdd4af09826614a2.mp3";